import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { fetchData, updateData, postData, VerifyData } from '../../../apiService';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Tooltip } from '@material-ui/core';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import AsyncCreatableSelect from 'react-select/async-creatable';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EditIcon from '@mui/icons-material/Edit';
import { useLocation } from 'react-router-dom';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const SaleReturnDetails = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL  
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderDetails, setOrderDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [formData, setFormData] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const history = useHistory();
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [defaultFreightGSTRate, setdefaultFreightGSTRate] = useState(0);
    const [defaultPackingGSTRate, setdefaultPackingGSTRate] = useState(0);
    const [SaleDraftId, setSaleDraftId] = useState({});
    const location = useLocation();
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, userId, token, logout]);

    useEffect(() => {
        fetchData('SaleReturnApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setSaleDraftId(response.response_data.Sale.Id);
                    setSelectedItems(response.response_data.SaleDetails);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    // Helper function to parse and handle NaN values as 0
    const parseAndFix = (val) => parseFloat(val) || 0;
    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = selectedItems.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [showModal, setShowModal] = useState(false);
    const opendatamodal = () => {
        setShowModal(true);
    };

    const closeDataModal = () => {
        console.log('Closing modal');
        setShowModal(false);
    };

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    const [isModalOpenverify, setIsModalOpenverify] = useState(false);
    const openModalverify = () => setIsModalOpenverify(true);
    const closeModalverify = () => setIsModalOpenverify(false);


    useEffect(() => {
        const shouldReload = localStorage.getItem('shouldReload') === 'true';

        if (location.state?.from === '/SaleIndex' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
    }, [location]);

    //     return (
    //         <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '100%', marginTop: '-10px' }}>

    //             <div className="flex flex-wrap justify-between items-center mb-4">
    //                 <h6
    //                     className="uppercase tracking-wide text-black font-serif flex-grow"
    //                     style={{
    //                         fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
    //                         color: 'black',
    //                         marginTop: '10px',
    //                     }}
    //                 >
    //                     Sale Return Details
    //                 </h6>

    //                 <div className="flex items-center w-full sm:w-auto sm:ml-4" style={{ marginRight: '120px', marginTop: '20px' }}>
    //                     <div className="mr-4">
    //                         <input
    //                             className="shadow text-gray-700 leading-tight"
    //                             type="text"
    //                             placeholder="Search..."
    //                             value={searchQuery}
    //                             onChange={handleSearch}
    //                             onFocus={() => setIsFocused(true)}
    //                             onBlur={() => setIsFocused(false)}
    //                             style={{
    //                                 width: isFocused ? '200px' : '170px',
    //                                 height: '30px',
    //                                 border: '1px solid #ccc',
    //                                 borderRadius: '15px',
    //                                 padding: '0 20px',
    //                                 transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
    //                                 outline: 'none',
    //                                 borderColor: isFocused ? 'darkcyan' : '#ccc',
    //                                 boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
    //                             }}
    //                         />
    //                     </div>

    //                     <div className="mr-4">
    //                         <label className="uppercase tracking-wide text-black text-xs font-bold" htmlFor="billDate" style={{ fontSize: '12px' }}>
    //                             Item Count :
    //                             <span style={{ color: '#F2613F', fontSize: '14px', marginLeft: '4px' }}>
    //                                 {selectedItems.length}
    //                             </span>
    //                         </label>
    //                     </div>

    //                     <div>
    //                         <label className="uppercase tracking-wide text-black text-xs font-bold" htmlFor="totalQuantity" style={{ fontSize: '12px' }}>
    //                             Total QTY :
    //                             <span style={{ color: 'green', fontSize: '14px', marginLeft: '4px' }}>
    //                                 {formData.TotalQuantity}
    //                             </span>
    //                         </label>
    //                     </div>
    //                 </div>

    //                 <div className="flex mt-8 w-full sm:w-auto">

    //                     <Button
    //                         color="error"
    //                         component={Link}
    //                         to={{
    //                             pathname: "/SaleReturnIndex",
    //                             state: { from: "/SaleReturnDetails" },
    //                         }}
    //                         onClick={() => {
    //                             localStorage.setItem('shouldReload', 'true');
    //                         }}
    //                         className="linkcolor"
    //                         // style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
    //                         style={{
    //                             background: 'linear-gradient(to right, #F1D3CE,#F1D3CE)',
    //                             color: 'black',
    //                             fontWeight: 'bolder',
    //                             textTransform: 'none',
    //                             boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
    //                             maxHeight: '25px',
    //                             //marginLeft: '5px',
    //                             marginLeft: '10px',

    //                         }}
    //                     >
    //                         <CloseIcon style={{ color: '#A91D3A', fontWeight: 'bolder' }} /><b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Back</b>
    //                     </Button>

    //                 </div>
    //             </div>

    //             {errorMessage && <p className="text-red-500">{errorMessage}</p>}
    //             <div className="w-full flex flex-wrap" style={{ backgroundColor: '#c9dedb', padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>


    //                 <div className="w-full pr-4" style={{ marginTop: '-0.21%' }}>
    //                     <div className="w-full mb-2 flex">

    //                         <div className="w-4/5 mr-2">
    //                             <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName">
    //                                 Customer Name
    //                                 <span className="text-red-500">*</span>
    //                             </label>
    //                             <input
    //                                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                 value={formData.CustomerName}
    //                                 type="text"
    //                                 placeholder="CustomerName"
    //                                 name='CustomerName'
    //                                 readOnly
    //                             />
    //                         </div>

    //                         <div className="w-1/5 mr-2">
    //                             <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
    //                                 Invoice Type
    //                                 <span className="text-red-500">*</span>
    //                             </label>

    //                             <input
    //                                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                 value={formData.InvoiceTypeName}
    //                                 type="text"
    //                                 placeholder="InvoiceTypeName"
    //                                 name='InvoiceTypeName'
    //                                 readOnly
    //                             />
    //                         </div>

    //                         <div className="w-1/5 mr-2">
    //                             <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
    //                                 Sale Bill Date
    //                                 <span className="text-red-500">*</span>
    //                             </label>
    //                             <input
    //                                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                 value={formatDateForInput(formData.SaleBillDate)}
    //                                 type="date"
    //                                 name='SaleBillDate'
    //                                 readOnly
    //                             />
    //                         </div>

    //                         <div className="w-1/5 mr-2">
    //                             <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
    //                                 Sale Bill Number
    //                                 <span className="text-red-500">*</span>
    //                             </label>
    //                             <input
    //                                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                 value={formData.SaleBillNumber}
    //                                 type="text"
    //                                 placeholder="Sale Bill Number"
    //                                 name='SaleBillNumber'

    //                             />
    //                         </div>

    //                         <div className="w-1/5 mr-2">
    //                             <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
    //                                 Sale RTN Date
    //                                 <span className="text-red-500">*</span>
    //                             </label>
    //                             <input
    //                                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                 value={formatDateForInput(formData.BillDate)}
    //                                 type="date"
    //                                 name='BillDate'

    //                             />
    //                         </div>

    //                         <div className="w-1/5 mr-2">
    //                             <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
    //                                 Sale RTN Number
    //                                 <span className="text-red-500">*</span>
    //                             </label>
    //                             <input
    //                                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                 value={`${formData.BillPrefix || ''}/${formData.BillNumber || ''}/${formData.FinYear || ''}`}
    //                                 type="text"
    //                                 placeholder="Bill Number"
    //                                 name='BillNumber'
    //                                 readOnly
    //                             />
    //                         </div>


    //                     </div>

    //                     <div className="w-full mb-2 flex" style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: '10px', height: '45%' }}>

    //                         <div className="w-1/3 mr-2" style={{ marginTop: '15px', marginLeft: '20px' }}>
    //                             <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
    //                                 Amount :
    //                                 <span style={{ color: 'red', fontSize: '14px' }}>{formData.TotalAmount}</span>
    //                             </label>
    //                             <div className="w-full mr-2">
    //                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
    //                                     R.Off
    //                                 </label>
    //                                 <input
    //                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                     value={formData.RoundOff}
    //                                     type="text"
    //                                     placeholder="RoundOff"
    //                                     style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
    //                                     name='RoundOff'
    //                                     readOnly
    //                                 />
    //                             </div>
    //                         </div>

    //                         <div className="w-1/4 mr-2" style={{ marginTop: '15px' }}>
    //                             <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
    //                                 Dis : <span style={{ color: 'green', fontSize: '14px' }}>{formData.DiscountAmount}</span>
    //                                 {formData.DiscountAmount > 0 && (

    //                                     <ArrowDownwardIcon
    //                                         style={{
    //                                             color: 'green',
    //                                             fontSize: '16px',
    //                                             marginLeft: '5px',
    //                                             verticalAlign: 'middle',
    //                                         }}
    //                                     />
    //                                 )}
    //                                 {formData.DiscountAmount < 0 && (
    //                                     <ArrowUpwardIcon
    //                                         style={{
    //                                             color: 'red',
    //                                             fontSize: '16px',
    //                                             marginLeft: '5px',
    //                                             verticalAlign: 'middle',
    //                                         }}
    //                                     />
    //                                 )}
    //                             </label>
    //                             <div className="w-full mr-2">
    //                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
    //                                     Total
    //                                 </label>
    //                                 <input
    //                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                     value={formData.GrandTotal}
    //                                     type="text"
    //                                     placeholder="GrandTotal"
    //                                     style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
    //                                     name='GrandTotal'
    //                                     readOnly
    //                                 />
    //                             </div>


    //                         </div>

    //                         <div className="w-1/4 mr-2" style={{ marginTop: '15px' }}>
    //                             <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
    //                                 CGST :  <span style={{ color: 'red', fontSize: '14px' }}>{formData.CGSTAmount}</span>
    //                             </label>

    //                             <div className="w-full mr-2">
    //                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
    //                                     Cash
    //                                 </label>
    //                                 <input
    //                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                     value={formData.CashAmount}
    //                                     type="number"
    //                                     placeholder="CashAmount"
    //                                     style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
    //                                     name='CashAmount'
    //                                     max={formData.GrandTotal}
    //                                     min="0"
    //                                     readOnly
    //                                 />
    //                             </div>

    //                         </div>



    //                         <div className="w-1/4 mr-2" style={{ marginTop: '15px' }}>
    //                             <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
    //                                 SGST :
    //                                 <span style={{ color: 'red', fontSize: '14px' }}>{formData.SGSTAmount}</span>

    //                             </label>
    //                             <div className="w-full mr-2">
    //                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
    //                                     Card
    //                                 </label>
    //                                 <input
    //                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                     value={formData.CardAmount}
    //                                     type="number"
    //                                     placeholder="CardAmount"
    //                                     style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
    //                                     name='CardAmount'
    //                                     max={formData.GrandTotal}
    //                                     min="0"
    //                                     readOnly
    //                                 />
    //                             </div>

    //                         </div>


    //                         <div className="w-1/4 mr-2" style={{ marginTop: '15px' }}>
    //                             <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
    //                                 IGST: <span style={{ color: 'red', fontSize: '14px' }}>{formData.IGSTAmount}</span>

    //                             </label>
    //                             <div className="w-full mr-2">
    //                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
    //                                     UPI
    //                                 </label>
    //                                 <input
    //                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                     value={formData.UPIAmount}
    //                                     type="number"
    //                                     placeholder="UPIAmount"
    //                                     style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
    //                                     name='UPIAmount'
    //                                     max={formData.GrandTotal}
    //                                     min="0"
    //                                     readOnly

    //                                 />
    //                             </div>

    //                         </div>



    //                         <div className="w-1/3 mr-2">
    //                             <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber"
    //                                 style={{ marginLeft: '-20px' }}>
    //                                 Freight  <span style={{ marginLeft: '5px', color: 'darkmagenta' }}> {formData.FreightGSTRate}%</span> <span style={{ marginLeft: '5px', color: 'red', fontWeight: 'bold' }}>{formData.FreightGSTAmount}</span>
    //                             </label>
    //                             <input
    //                                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                 value={formData.FreightAmount}
    //                                 type="text"
    //                                 placeholder="FreightAmount"
    //                                 style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
    //                                 name='FreightAmount'
    //                                 min="0"
    //                                 readOnly

    //                             />


    //                             <div className="w-full mr-2 relative" style={{ marginTop: '12px' }}>
    //                                 <input
    //                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                     value={formData.BalanceAmount || 0}
    //                                     type="text"
    //                                     style={{
    //                                         textAlign: 'right',
    //                                         fontWeight: 'bold',
    //                                         color: formData.BalanceAmount > 0 ? 'red' : 'inherit', // Highlight in red if BalanceAmount > 0                                      
    //                                         height: '32px',
    //                                     }}
    //                                     name="BalanceAmount"
    //                                     placeholder="Balance Amount"
    //                                     readOnly
    //                                 />
    //                                 <span
    //                                     style={{
    //                                         position: 'absolute',
    //                                         left: '10px',
    //                                         top: '50%',
    //                                         transform: 'translateY(-50%)',
    //                                         color: 'gray',
    //                                         fontWeight: 'bold',
    //                                         fontSize: '14px',
    //                                     }}
    //                                 >
    //                                     Bal.
    //                                 </span>
    //                             </div>

    //                         </div>

    //                         <div className="w-1/3 mr-2">
    //                             <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber"
    //                                 style={{ marginLeft: '-20px' }}>
    //                                 Packing  <span style={{ marginLeft: '5px', color: 'darkmagenta' }}> {formData.PackingGSTRate}%</span> <span style={{ marginLeft: '5px', color: 'red', fontWeight: 'bold' }}>{formData.PackingGSTAmount}</span>
    //                             </label>
    //                             <input
    //                                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                 value={formData.PackingAmount}
    //                                 type="text"
    //                                 placeholder="PackingAmount"
    //                                 style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
    //                                 name='PackingAmount'
    //                                 min="0"
    //                                 readOnly

    //                             />
    //                             <div className="w-full mr-3" style={{ marginTop: '8px', width: '180%' }}>
    //                                 <textarea
    //                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                     type="text"
    //                                     placeholder="Remarks"
    //                                     name="Remarks"
    //                                     rows={3}
    //                                     value={formData.Remarks}
    //                                     style={{ textAlign: 'left', fontWeight: 'bold', height: '50px' }}
    //                                     readOnly
    //                                 />
    //                             </div>
    //                         </div>

    //                         <div className="w-1/4 mr-2">
    //                             <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
    //                                 TCS
    //                             </label>
    //                             <input
    //                                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                 value={formData.TCSAmount}
    //                                 type="number"
    //                                 placeholder="TCS Amount"
    //                                 style={{ textAlign: 'right', fontWeight: 'bold', height: '32px' }}
    //                                 name='TCSAmount'
    //                                 min="0"
    //                                 readOnly

    //                             />
    //                         </div>

    //                         <div className="w-1/4 mr-2" style={{ marginTop: '15px' }}>
    //                             {(formData.UPIAmount > 0 || formData.CardAmount > 0) && (
    //                                 <div className="w-full mr-2" style={{ marginTop: '10px', marginLeft: '15px' }}>

    //                                     <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
    //                                         Bank
    //                                     </label>
    //                                     <input
    //                                         className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                                         value={formData.BankName}
    //                                         type="text"
    //                                         placeholder="Bank Name"
    //                                         style={{ fontWeight: 'bold', height: '32px', width: '200px' }}
    //                                         name="BankName"
    //                                         readOnly
    //                                     />

    //                                 </div>
    //                             )}
    //                         </div>
    //                     </div>

    //                     {/* Purchase Order Table */}
    //                     <div className="w-full mb-2" style={{ marginTop: '15px', overflow: 'auto' }}>
    //                         <table
    //                             className="min-w-full bg-white shadow-md rounded-lg overflow-hidden"
    //                             style={{ borderCollapse: 'collapse' }}
    //                         >
    //                             <thead className="bg-gray-100">
    //                                 <tr>
    //                                     <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px' }}>SL.No</th>
    //                                     <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px' }}>ITEM NAME</th>
    //                                     <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'center' }}>S.QTY</th>
    //                                     <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'center' }}>R.QTY</th>
    //                                     <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>RATE</th>
    //                                     <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>AMOUNT</th>
    //                                     <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>DIS %</th>
    //                                     <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>DIS ₹</th>
    //                                     <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>TAXABLE</th>
    //                                     <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>GST ₹</th>
    //                                     <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>TOTAL</th>
    //                                 </tr>
    //                             </thead>

    //                             <tbody>
    //                                 {filteredData.map((item, index) => {
    //                                     return (
    //                                         <tr key={index} className="border-b"
    //                                             style={{
    //                                                 backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
    //                                                 borderBottom: '1px solid #E0E0E0',
    //                                                 transition: 'transform 0.2s ease-in-out',
    //                                                 cursor: 'pointer',
    //                                             }}
    //                                             onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
    //                                             onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
    //                                         >
    //                                             <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '1px', textAlign: 'center', width: '75px' }}>
    //                                                 {index + 1}

    //                                             </td>
    //                                             <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '3px', width: '250px' }}>{item.ItemName}</td>
    //                                             <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
    //                                                 <input
    //                                                     type="number"
    //                                                     value={item.SaleQuantity}
    //                                                     className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
    //                                                     style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#FBF6E9', textAlign: 'right' }}
    //                                                     aria-label={`Order quantity for item ${item.Id}`}
    //                                                     readonly
    //                                                 />
    //                                             </td>

    //                                             <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
    //                                                 <input
    //                                                     type="number"
    //                                                     value={item.Quantity}
    //                                                     readOnly
    //                                                     className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
    //                                                     style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#FBF6E9', textAlign: 'right' }}
    //                                                     aria-label={`Order quantity for item ${item.Id}`}
    //                                                     name="Quantity"
    //                                                 />
    //                                             </td>
    //                                             <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
    //                                                 <input
    //                                                     value={item.Rate || 0}
    //                                                     readOnly
    //                                                     className="w-full px-1 py-1 border rounded-md"
    //                                                     style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#CBE4DE', textAlign: 'right' }}
    //                                                     type="number"
    //                                                     name="Rate"
    //                                                 />
    //                                             </td>
    //                                             <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
    //                                                 <input
    //                                                     value={item.Amount || 0}
    //                                                     className="w-full px-1 py-1 border rounded-md"
    //                                                     style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
    //                                                     name="Amount"
    //                                                     readOnly
    //                                                 />
    //                                             </td>
    //                                             <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
    //                                                 <input
    //                                                     value={item.DiscountPercentage || 0}
    //                                                     className="w-full px-1 py-1 border rounded-md"
    //                                                     style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#F6D6D6', textAlign: 'right' }}
    //                                                     type="number"
    //                                                     name="DiscountPercentage"
    //                                                     readOnly
    //                                                 />
    //                                             </td>
    //                                             <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
    //                                                 <input
    //                                                     value={item.DiscountAmount || 0}
    //                                                     readOnly
    //                                                     className="w-full px-1 py-1 border rounded-md"
    //                                                     style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
    //                                                 />
    //                                             </td>
    //                                             <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
    //                                                 <input
    //                                                     value={item.TaxableAmount || 0}
    //                                                     className="w-full px-1 py-1 border rounded-md"
    //                                                     style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
    //                                                     readOnly
    //                                                 />
    //                                             </td>
    //                                             <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
    //                                                 <input
    //                                                     value={parseFloat(item.CGSTAmount) + parseFloat(item.SGSTAmount) + parseFloat(item.IGSTAmount)}
    //                                                     className="px-1 py-1 border rounded-md"
    //                                                     style={{
    //                                                         fontSize: '13px',
    //                                                         fontWeight: 'bold',
    //                                                         textAlign: 'right',
    //                                                         width: '70%', // Adjust the width to fit
    //                                                     }}
    //                                                     readOnly
    //                                                 />
    //                                                 <span style={{ marginLeft: '3px', color: 'darkmagenta', fontSize: '11px', fontWeight: 'bold', }}>
    //                                                     {item.GSTRate ? parseFloat(item.GSTRate).toString() : 0}%
    //                                                 </span>
    //                                             </td>
    //                                             <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
    //                                                 <input
    //                                                     value={item.TotalAmount || 0}
    //                                                     readOnly
    //                                                     className="w-full px-1 py-1 border rounded-md"
    //                                                     style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#D3F1DF', textAlign: 'right' }}
    //                                                 />
    //                                             </td>

    //                                         </tr>
    //                                     );
    //                                 })}
    //                             </tbody>
    //                         </table>
    //                     </div>

    //                 </div>
    //             </div>

    //         </div>
    //     );
    // };


    return (
        <div
            style={{
                fontFamily: "Segoe UI, sans-serif",
                fontSize: "12px",
                width: "100%",
                padding: "5px",
                marginTop: '-10px'
            }}
        >
            {/* Header */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "6px",
                    marginBottom: "12px"
                }}
            >
                <h6 className="uppercase tracking-wide font-serif text-black mt-2">
                    Sale Return Details
                </h6>

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "350px 130px 130px 100px", // 4 columns
                        gap: "10px",
                        marginBottom: "12px",
                        alignItems: "end"
                    }}
                >
                    {/* Supplier */}
                    <div>
                        <label style={{ fontSize: "11px", fontWeight: "600" }}>
                            Customer
                            <span style={{ color: "black", marginLeft: "8px" }}>
                                Invoice : {formData.InvoiceTypeName}
                            </span>
                        </label>
                        <input
                            type="text"
                            name="CustomerName"
                            value={formData.CustomerName}
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "12px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px"
                            }}
                            readOnly
                        />
                    </div>

                    {/* Purchased Bill No */}
                    <div>
                        <label style={{ fontSize: "11px", fontWeight: "600" }}>
                            Sale Bill No
                        </label>
                        <input
                            type="text"
                            name="SaleBillNumber"
                            value={formData.SaleBillNumber}
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "12px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px"
                            }}
                            readOnly
                        />
                    </div>

                    {/* Purchased Bill Date */}
                    <div>
                        <label style={{ fontSize: "11px", fontWeight: "600" }}>
                            Sale Bill Date
                        </label>
                        <input
                            type="date"
                            name="SaleBillDate"
                            value={formatDateForInput(formData.SaleBillDate)}
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "12px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px"
                            }}
                            disabled
                        />
                    </div>

                </div>

                <div className="flex items-center gap-3 mt-2 md:mt-0" style={{ flexShrink: 0 }}>
                    {/* Back To List Button */}
                    <Button
                        variant="contained"
                        component={Link}
                        to="/SaleReturnIndex"
                        className="linkcolor"
                        onClick={() => localStorage.setItem("shouldReload", "true")}
                        style={{
                            height: "25px",
                            minWidth: "90px",
                            borderRadius: "6px",
                            backgroundColor: "#F3F4F6", // light gray ERP style
                            color: "#1E3A8A",
                            fontWeight: 600,
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            textTransform: "none",
                            transition: "background-color 0.2s, box-shadow 0.2s",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#E5E7EB")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#F3F4F6")}
                    >
                        Back To List
                    </Button>
                </div>
            </div>

            {/* Top Section - Supplier & Bill */}
            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <div
                style={{
                    display: "grid",
                    //gridTemplateColumns: "130px repeat(10, 1fr)",
                    // gridTemplateColumns: "repeat(11, 1fr)",
                    //gridTemplateColumns: "95px 105px 140px 140px 140px 130px 130px 130px 130px 130px 130px",
                    gridTemplateColumns: "95px 105px 140px 140px repeat(7, 1fr)",
                    gap: "10px",
                    marginBottom: "12px",
                    alignItems: "end" // ✅ aligns all inputs properly
                }}
            >
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}> Sale RTN Date</label>
                    <input
                        type="date"
                        name="BillDate"
                        value={formatDateForInput(formData.BillDate)}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                        disabled
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>
                        Sale RTN Number
                    </label>
                    <input
                        type="text"
                        name="BillNumber"
                        value={`${formData.BillPrefix || ''}/${formData.BillNumber || ''}/${formData.FinYear || ''}`}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                        disabled
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Freight
                        <span style={{ color: 'darkmagenta', marginLeft: '3px' }}>({formData.FreightGSTRate}%)</span>
                        <span style={{ color: 'red', marginLeft: '3px' }}>{formData.FreightGSTAmount}</span>
                    </label>
                    <input
                        type="number"
                        name="FreightAmount"
                        value={formData.FreightAmount}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                        disabled
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Packing
                        <span style={{ color: 'darkmagenta', marginLeft: '3px' }}> ({formData.PackingGSTRate}%)</span>
                        <span style={{ color: 'red', marginLeft: '3px' }}>{formData.PackingGSTAmount}</span>
                    </label>
                    <input
                        type="number"
                        name="PackingAmount"
                        value={formData.PackingAmount}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                        disabled
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>TCS</label>
                    <input
                        type="number"
                        name="TCSAmount"
                        value={formData.TCSAmount}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                        disabled
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Round Off</label>
                    <input
                        type="number"
                        name="RoundOff"
                        value={formData.RoundOff}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                        disabled
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Total</label>
                    <input
                        type="number"
                        name="GrandTotal"
                        value={formData.GrandTotal}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                            color: "#0D47A1"
                        }}
                        disabled
                    />
                </div>

                {/* Cash */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Cash</label>
                    <input
                        type="number"
                        name="CashAmount"
                        placeholder="CashAmount"
                        value={formData.CashAmount}
                        min="0"
                        max={Math.max(
                            0,
                            parseFloat(formData.GrandTotal || 0) -
                            (parseFloat(formData.CardAmount || 0) +
                                parseFloat(formData.UPIAmount || 0))
                        )}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "15px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                        }}
                        disabled
                    />
                </div>

                {/* Card */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Card</label>
                    <input
                        type="number"
                        name="CardAmount"
                        placeholder="CardAmount"
                        value={formData.CardAmount}
                        min="0"
                        max={Math.max(
                            0,
                            parseFloat(formData.GrandTotal || 0) -
                            (parseFloat(formData.CashAmount || 0) +
                                parseFloat(formData.UPIAmount || 0))
                        )}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "15px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                        }}
                        disabled
                    />
                </div>

                {/* UPI */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>UPI</label>
                    <input
                        type="number"
                        name="UPIAmount"
                        placeholder="UPIAmount"
                        value={formData.UPIAmount}
                        min="0"
                        max={Math.max(
                            0,
                            parseFloat(formData.GrandTotal || 0) -
                            (parseFloat(formData.CashAmount || 0) +
                                parseFloat(formData.CardAmount || 0))
                        )}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "15px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                        }}
                        disabled
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Balance</label>
                    <input
                        value={formData.BalanceAmount}
                        type="text"
                        placeholder="BalanceAmount"
                        style={{
                            textAlign: 'right',
                            color: formData.BalanceAmount > 0 ? 'red' : 'inherit',// Sets color to red if BlanceAmount > 0
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                            //color: "#0D47A1"
                        }}
                        name='BalanceAmount'
                        disabled
                    />
                </div>
                {/* </div> */}
            </div>

            {/* Amount Summary */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(6, 1fr)",
                    gap: "8px",
                    marginBottom: "12px",
                    fontSize: "12px"
                }}
            >
                <div>
                    Amount:{" "}
                    <span style={{ color: "#B71C1C", fontWeight: "bold" }}>
                        {formData.Amount}
                    </span>
                </div>
                <div>
                    Discount:{" "}
                    <span style={{ color: "#B71C1C", fontWeight: "bold" }}>
                        {formData.DiscountAmount}
                    </span>
                </div>
                <div>
                    Taxable:{" "}
                    <span style={{ color: "#B71C1C", fontWeight: "bold" }}>
                        {formData.TaxableAmount}
                    </span>
                </div>
                <div>
                    CGST: <span style={{ color: "#B71C1C", fontWeight: "bold" }}>{formData.CGSTAmount}</span>
                </div>
                <div>
                    SGST: <span style={{ color: "#B71C1C", fontWeight: "bold" }}>{formData.SGSTAmount}</span>
                </div>
                <div>
                    IGST: <span style={{ color: "#B71C1C", fontWeight: "bold" }}>{formData.IGSTAmount}</span>
                </div>
            </div>

            {/* Data Table */}
            <div
                style={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    marginBottom: "12px",
                    border: "1px solid #999",
                    borderRadius: "4px",
                    backgroundColor: "#fff",
                }}
            >
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "13px",
                        fontFamily: "monospace",
                    }}
                >
                    <thead style={{ backgroundColor: "#1F2A38", color: "#FFFFFF" }}>
                        <tr>
                            {[
                                "SL.No",
                                'ITEM',
                                'S.QTY',
                                'R.QTY',
                                'RATE',
                                'AMOUNT',
                                'DIS %',
                                'DIS ₹',
                                'TAXABLE',
                                'GST ₹',
                                'TOTAL',

                            ].map((header, idx) => (
                                <th
                                    key={idx}
                                    style={{
                                        padding: "3px",
                                        //textAlign: idx > 1 & 9 ? "right" : "left",
                                        textAlign: idx > 1 ? "center" : "left",
                                        borderBottom: "1px solid #ccc",
                                        textTransform: 'uppercase',
                                        fontSize: '10px'
                                    }}                                >
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.map((item, index) => (
                            <tr
                                key={index}
                                style={{
                                    backgroundColor: index % 2 === 0 ? "#FDFDFD" : "#F5F7FA",
                                    borderBottom: "1px solid #ddd",
                                }}
                            >
                                {/* SL.No + Delete */}
                                <td style={{ padding: "4px 6px", textAlign: "center" }}>
                                    {index + 1}
                                </td>

                                {/* Item Name */}
                                <td
                                    style={{
                                        fontSize: "13px",
                                        //fontWeight: "bold",
                                        padding: "4px",
                                        minWidth: "200px",
                                    }}
                                >
                                    {item.ItemName}
                                </td>
                                {/* Saled Quantity */}
                                <td style={{ padding: "2px", textAlign: "right", width: "70px" }}>
                                    <input
                                        type="number"
                                        value={item.SaleQuantity}
                                        name="SaledQuantity"
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#ECFAE5",
                                            //fontWeight: "bold",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                        }}
                                        disabled
                                    />
                                </td>
                                {/* Quantity */}
                                <td style={{ padding: "2px", textAlign: "right", width: "70px" }}>
                                    <input
                                        type="number"
                                        value={item.Quantity}
                                        //onChange={(e) => handleCalculation(e, index, 'Quantity')}
                                        className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                        min="0"
                                        aria-label={`ReturnQuantity for item ${item.Id}`}
                                        name="Quantity"
                                        max={item.SaleQuantity}
                                        onClick={(e) => e.target.select()}
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                        }}
                                        disabled
                                    />
                                </td>

                                {/* Rate */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        type="number"
                                        value={item.Rate || 0}
                                        name="Rate"
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#F6D6D6",
                                            //fontWeight: "bold",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                        }}
                                        disabled
                                    />
                                </td>

                                {/* Amount */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.Amount || 0}
                                        disabled
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            //backgroundColor: "#fdfdfd",
                                            padding: "2px",
                                            borderRadius: "3px",
                                            //fontWeight: "bold",
                                        }}
                                    />
                                </td>

                                {/* Discount % */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        type="number"
                                        value={item.DiscountPercentage || 0}
                                        name="DiscountPercentage"
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#F2EFE7",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            //fontWeight: "bold",
                                        }}
                                        disabled
                                    />
                                </td>

                                {/* Discount Amount */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.DiscountAmount || 0}
                                        disabled
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            //fontWeight: "bold",
                                        }}
                                    />
                                </td>

                                {/* Taxable */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.TaxableAmount || 0}
                                        disabled
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            //fontWeight: "bold",
                                        }}
                                    />
                                </td>

                                {/* GST */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={
                                            parseFloat(item.CGSTAmount) +
                                            parseFloat(item.SGSTAmount) +
                                            parseFloat(item.IGSTAmount)
                                        }
                                        disabled
                                        style={{
                                            width: "70%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            // fontWeight: "bold",
                                        }}
                                    />
                                    <span
                                        style={{
                                            marginLeft: "4px",
                                            color: "darkmagenta",
                                            fontSize: "11px",
                                            //fontWeight: "bold",
                                        }}
                                    >
                                        {item.GSTRate ? parseFloat(item.GSTRate) : 0}%
                                    </span>
                                </td>

                                {/* Total */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.TotalAmount || 0}
                                        disabled
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#DDE9EC",
                                            border: "1px solid #888",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            fontWeight: "bold",
                                            color: 'brown'
                                        }}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Extra Charges + Remarks */}
            {/* Top Section - Remarks & Bank */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: formData.UPIAmount > 0 || formData.CardAmount > 0
                        ? "3fr 1fr" // show both side by side
                        : "1fr",    // only Remarks
                    gap: "8px",
                    //marginBottom: "13px",
                    fontSize: "13px",
                    alignItems: "end",
                }}
            >
                {/* Remarks */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Remarks</label>
                    <textarea
                        name="Remarks"
                        value={formData.Remarks}
                        rows={1}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "13px",
                            width: "100%",
                            padding: "4px",
                            resize: "vertical",
                        }}
                        disabled
                    />
                </div>

                {/* Bank - conditional */}
                {(formData.UPIAmount > 0 || formData.CardAmount > 0) && (
                    <div>
                        <label style={{ fontSize: "11px", fontWeight: "600" }}>Bank</label>
                        <input
                            type="text"
                            name="BankName"
                            value={formData.BankName}
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "12px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px"
                            }}
                            readOnly
                        />
                    </div>
                )}
            </div>
        </div >
    );
}

export default SaleReturnDetails;
